import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkStatus, AuthError, composeAuth } from "../../helpers/utils";
import { logoutUser } from "../actions/account";
import querystring from "query-string";

export const getGoalSchemaById = createAsyncThunk(
  "goals/getGoalSchemaById",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/schema/tag/${payload?.tagId}/institutionId/${payload?.id}/me`
          : `/api/goals/schema/tag/${payload?.tagId}/institutionId/${payload?.id}`);
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalByIdLazy = createAsyncThunk(
  "goals/getGoalByIdLazy",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/${payload?.id}/tag/${payload?.tagId}/me`
          : `/api/goals/${payload?.id}/tag/${payload?.tagId}`);
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalById = createAsyncThunk(
  "goals/getGoalById",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/${payload?.id}/me`
          : `/api/goals/${payload?.id}`);
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalDetailsForSubSectionEditById = createAsyncThunk(
  "goals/getGoalDetailsForSubSectionEditById",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/${payload?.id}/tag/${payload?.tagId}/me`
          : `/api/goals/${payload?.id}/tag/${payload?.tagId}`);
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return { validateData, otherGoalFetch: payload?.otherGoalFetch };
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalByParentGoalId = createAsyncThunk(
  "goals/getGoalByParentGoalId",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/parent/${payload?.parentId}/me`
          : `/api/goals/parent/${payload?.parentId}`)
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalByParentGoalIdWithPagination = createAsyncThunk(
  "goals/getGoalByParentGoalId",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/parent/${payload?.parentId}/me?offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`
          : `/api/goals/parent/${payload?.parentId}?offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`)
      // `/api/locations/institution/${payload?.institutionId}?offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.requestBody)
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
export const addGoals = createAsyncThunk(
  "goals/addGoals",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals`;
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.requestBody),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);


export const createDuplicateGoals = createAsyncThunk(
  "goals/createDuplicateGoals",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/duplicate`;
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.requestBody),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalsByTagId = createAsyncThunk(
  "goals/getGoalsByTagId",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER + `/api/goals/tag/${payload?.id}`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalsByProductId = createAsyncThunk(
  "goals/getGoalsByProductId",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/product/${payload?.id}/me`
          : `/api/goals/product/${payload?.id}`);
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();

      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalsByModuleId = createAsyncThunk(
  "goals/getGoalsByModuleId",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/type/${payload?.module}/module/${payload?.id}/me?offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`
          : `/api/goals/type/${payload?.module}/module/${payload?.id}?offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`);
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();

      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalsByMultipleTagIds = createAsyncThunk(
  "goals/getGoalsByMultipleTagIds",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/tag_ids/me?${querystring.stringify({
            tag_ids: payload?.tag_ids,
          })}`
          : `/api/goals/tag_ids?${querystring.stringify({
            tag_ids: payload?.tag_ids,
          })}`);
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData?.data;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalsByMultipleTagIdsWithPagination = createAsyncThunk(
  "goals/getGoalsByMultipleTagIdsWithPagination",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/tag_ids/me?${querystring.stringify({
            tag_ids: payload?.tag_ids,
          })}&offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`
          : `/api/goals/tag_ids?${querystring.stringify({
            tag_ids: payload?.tag_ids,
          })}&offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`);
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData?.data;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalsByMultipleTagIdsWithAiSearchPagination = createAsyncThunk(
  "goals/getGoalsByMultipleTagIdsWithAiSearchPagination",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        `/api/goals/ai-search/tag_ids?${querystring.stringify({
          tag_ids: payload?.tag_ids,
        })}&offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`;
      const body = payload?.body || {};
      const filters = { ...body };
      const sort = filters.sort;
      const favorite = filters.favorite;
      delete filters.sort;
      delete filters.favorite;
      delete filters.aiSearch;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization,
        },
        body: JSON.stringify({
          prompt: payload?.prompt,
          filters,
          ...(sort ? { sort } : {}),
          ...(favorite === true ? { favorite: true } : {}),
        }),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData?.data;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
export const getGoalsByMultipleTagIdsForUnits = createAsyncThunk(
  "goals/getGoalsByMultipleTagIdsForUnits",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/units/me/goals/tagids?${querystring.stringify({
            tag_ids: payload?.tag_ids,
          })}&offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`
          : `/api/units/me/goals/tagids?${querystring.stringify({
            tag_ids: payload?.tag_ids,
          })}&offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`);
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData?.data;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const editGoalById = createAsyncThunk(
  "goals/editGoalById",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/${payload?.id}/type/${payload?.isUser ? "me" : "all"}`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return { ...validateData, fromChildTable: payload?.fromChildTable };
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      let error = {}
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409
      }
      return thunkApi.rejectWithValue(error.statusCode ? error : err);
    }
  }
);

export const editGoalByIdLight = createAsyncThunk(
  "goals/editGoalByIdLight",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        `/api/goals/${payload?.id}/updateGoalLight/type/${payload?.isUser ? "me" : "all"}`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return { ...validateData, fromChildTable: payload?.fromChildTable };
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      let error = {}
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409
      }
      return thunkApi.rejectWithValue(error.statusCode ? error : err);
    }
  }
);
export const editGoalByIdQueued = createAsyncThunk(
  "goals/editGoalByIdQueued",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/${payload?.id}/type/${payload?.isUser ? "me" : "all"}/queued`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return { ...validateData, fromChildTable: payload?.fromChildTable };
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      let error = {}
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409
      }
      return thunkApi.rejectWithValue(error.statusCode ? error : err);
    }
  }
);
export const getLatestGoalSubmission = createAsyncThunk(
  "goals/getLatestGoalSubmission",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER + `/api/goals/${payload?.id}/latest-goal-save`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData?.data;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const retryQueuedGoalSubmission = createAsyncThunk(
  "goals/retryQueuedGoalSubmission",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        `/api/goals/edit-goal-queue/retry/${payload?.goalSaveId}/institution/${payload?.institutionId}`;

      const fetchOptions = {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      };

      if (payload?.body) {
        fetchOptions.body = JSON.stringify(payload?.body);
      }

      const res = await fetch(url, fetchOptions);
      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getSurveySubmissionsByInstitutionId = createAsyncThunk(
  "goals/getSurveySubmissionsByInstitutionId",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        `/api/goals/edit-goal-queue/failed/institution/${payload?.institutionId}`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
export const dismissQueuedGoalSubmission = createAsyncThunk(
  "goals/dismissQueuedGoalSubmission",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        `/api/goals/goal-save/${payload?.goalSaveId}/institution/${payload?.institutionId}/dismiss`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const editChildGoalById = createAsyncThunk(
  "goals/editChildGoalById",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/${payload?.id}/type/${payload?.isUser ? "me" : "all"}`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      let error = {}
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409
      }
      return thunkApi.rejectWithValue(error.statusCode ? error : err);
    }
  }
);

export const markGoalAsFavorite = createAsyncThunk(
  "goals/markGoalAsFavorite",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/favorites/update/${payload?.id}`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return { goalId: payload?.id, validateData, isFavorite: validateData?.data?.goal?.isFavorite };
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      let error = {}
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409
      }
      return thunkApi.rejectWithValue(error.statusCode ? { error, goalId: payload?.id, isFavorite: payload?.prevIsFav } : { err, goalId: payload?.id, isFavorite: payload?.prevIsFav });
    }
  }
);

export const delGoalById = createAsyncThunk(
  "goals/delGoalById",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/${payload.id}`;
      const res = await fetch(url, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);

      return validateData?.data;
    } catch (err) {
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getGoalsForCalender = createAsyncThunk(
  "goals/getGoalsForCalender",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser ? `/api/goals/calender/institution/${payload?.id}/me` : `/api/goals/calender/institution/${payload?.id}`);
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const editMultipleGoals = createAsyncThunk(
  "goals/editMultipleGoals",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER + `/api/goals/bulk/start_end_date`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.requestBody),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getPublicGoalSchema = createAsyncThunk(
  "goals/getPublicGoalSchema",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        `/api/goals/schema/tag/${payload?.tagName}/institutionId/${payload?.id}/public`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const addPublicGoals = createAsyncThunk(
  "goals/addPublicGoals",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/public`;
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.requestBody),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const editBulkGoals = createAsyncThunk(
  "goals/editBulkGoals",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/bulk`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.requestBody),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getClientLocationProfileForGoal = createAsyncThunk(
  "goals/getClientLocationProfileForGoal",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/schema/tag/${payload?.tagId}/institutionId/${payload?.id}/me`
          : `/api/goals/client/location/profiles/${payload?.id}`);
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);


export const checkGoalConflicts = createAsyncThunk(
  "goals/checkGoalConflicts",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/conflict`;
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.requestBody),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const checkRecentlyUpdatedGoal = createAsyncThunk(
  "goals/checkRecentlyUpdatedGoal",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/${payload?.id}/timestamp/${payload?.timestamp}`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      let error = {}
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409
      }
      return thunkApi.rejectWithValue(error.statusCode ? error : err);
    }
  }
);
let lastController = null;

// export const downloadGoalsCSV = createAsyncThunk(
//   "goals/downloadGoalsCSV",
//   async (payload, thunkApi) => {
//     try {
//       const Authorization = composeAuth(payload?.jwt);
//       const url = process.env.REACT_APP_SERVER + `/api/goals/csv-downlaod`;
//       const res = await fetch(url, {
//         method: "PATCH",
//         headers: {
//           "Content-type": "application/json",
//           Authorization,
//         },
//         body: JSON.stringify(payload?.body),
//       });

//       const response = await res.json();
//       const validateData = checkStatus(response);
//       return validateData;
//     } catch (err) {
//       if (err instanceof AuthError) {
//         thunkApi.dispatch(logoutUser());
//       }
//       let error = {}
//       if (err.message === "The goal was modified and has new data") {
//         error.statusCode = 409
//       }
//       return thunkApi.rejectWithValue(error.statusCode ? error : err);
//     }
//   }
// );

export const downloadGoalsCSV = createAsyncThunk(
  "goals/downloadGoalsCSV",
  async (payload, thunkApi) => {
    try {
      // 🔹 Abort previous call if still pending
      if (lastController) {
        lastController.abort();
      }
      const controller = new AbortController();
      lastController = controller;

      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/csv-downlaod`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
        signal: controller.signal,
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      // 🔹 Ignore AbortError (canceled request)
      if (err.name === "AbortError") {
        return thunkApi.rejectWithValue({ aborted: true });
      }

      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }

      let error = {};
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409;
      }

      return thunkApi.rejectWithValue(error.statusCode ? error : err);
    }
  }
);

export const editBulkGoalsCsv = createAsyncThunk(
  "goals/editBulkGoalsCsv",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/bulk-csv`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.requestBody),
      });
      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
export const filteredParentGoals = createAsyncThunk(
  "goals/filteredParentGoals",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/parent/${payload?.parentGoalId}/csv-download`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      let error = {}
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409
      }
      return thunkApi.rejectWithValue(error.statusCode ? error : err);
    }
  }
);
export const revertGoals = createAsyncThunk(
  "goals/revertGoals",
  async (payload, thunkApi) => {
    try {
      const url =
        `${process.env.REACT_APP_SERVER}/api/goals/revert/institution/${payload?.institutionId}`;

      const Authorization = composeAuth(payload?.jwt);

      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });
      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const revertGoalstById = createAsyncThunk(
  "goals/revertGoalstById",
  async (payload, thunkApi) => {
    try {
      const url = process.env.REACT_APP_SERVER + `/api/goals/revert/id/${payload?.id}`;
      const Authorization = composeAuth(payload?.jwt);

      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.requestBody),
      });

      const response = await res.json();

      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const parentGoalsByChildId = createAsyncThunk(
  "goals/parentGoalsByChildId",
  async (payload, thunkApi) => {
    try {
      const url =
        `${process.env.REACT_APP_SERVER}/api/goals/child/${payload?.childGoalId}/getParentGoalsByChildId`;

      const Authorization = composeAuth(payload?.jwt);

      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });
      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const childDocsbyParentId = createAsyncThunk(
  "goals/childDocsbyParentId",
  async (payload, thunkApi) => {
    try {
      const url =
        `${process.env.REACT_APP_SERVER}/api/goals/childDocs/${payload?.parent_goal_id}/childDocsByParentId`;

      const Authorization = composeAuth(payload?.jwt);

      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });
      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
export const appointmentForm = createAsyncThunk(
  "goals/appointmentForm",
  async (payload, thunkApi) => {
    try {
      const url = process.env.REACT_APP_SERVER + `/api/goals/appoinment/${payload.requestBody.goalId}/appoinmentId`;
      const Authorization = composeAuth(payload?.jwt);
      console.log('payload is', payload)
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.requestBody),
      });

      const response = await res.json();

      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const filteredListofAllChildGoals = createAsyncThunk(
  "goals/filteredListofAllChildGoals",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/parent/${payload?.parentGoalId}/childGoalsIds`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      let error = {}
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409
      }
      return thunkApi.rejectWithValue(error.statusCode ? error : err);
    }
  }
)

export const uploadPdfForGoalsGeneration = createAsyncThunk(
  "goals/uploadPdfForGoalsGeneration",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goalgenai`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      let error = {}
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409
      }
      return thunkApi.rejectWithValue(error.statusCode ? error : err);
    }
  }
);

export const getGeneratedGoals = createAsyncThunk(
  "goals/getGeneratedGoals",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/getgoalGenLog/${payload.id}/getGoalGen`
          : `/api/getgoalGenLog/${payload.id}/getGoalGen`);
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
export const getFinalGoals = createAsyncThunk(
  "goals/getFinalGoals",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/genid/${payload.id}/genid`
          : `/api/goals/genid/${payload.id}/genid`);
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const getAllGenAiGoals = createAsyncThunk(
  "goals/getAllGenAiGoals",
  async (payload, thunkApi) => {
    try {
      console.log('inside try')
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/getGenId/institution/${payload?.institutionId}/getAllGoalGen`
          : `/api/getGenId/institution/${payload?.institutionId}/getAllGoalGen`);
      console.log('here')
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
      });
      console.log('res', res)
      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
export const getGoalsByGroups = createAsyncThunk(
  "goals/getGoalsByGroups",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/group_by/tag_ids/me?${querystring.stringify({
            tag_ids: payload?.tag_ids,
          })}`
          : `/api/goals/group_by/tag_ids?${querystring.stringify({
            tag_ids: payload?.tag_ids,
          })}`);
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData?.data;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);

export const customFilters = createAsyncThunk(
  "goals/customFilters",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url = process.env.REACT_APP_SERVER + `/api/goals/group_by`;
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      let error = {}
      if (err.message === "The goal was modified and has new data") {
        error.statusCode = 409
      }
      return thunkApi.rejectWithValue(error.statusCode ? error : err);
    }
  }
);

export const getGoalsByMultipleTagIdsWithPaginationForBookings = createAsyncThunk(
  "goals/getGoalsByMultipleTagIdsWithPaginationForBookings",
  async (payload, thunkApi) => {
    try {
      const Authorization = composeAuth(payload?.jwt);
      const url =
        process.env.REACT_APP_SERVER +
        (payload?.isUser
          ? `/api/goals/booking/tag_ids/me?${querystring.stringify({
            tag_ids: payload?.tag_ids,
          })}&offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`
          : `/api/goals/booking/tag_ids?${querystring.stringify({
            tag_ids: payload?.tag_ids,
          })}&offset=${payload?.offset || 0}&limit=${payload?.limit || 20}`);
      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization,
        },
        body: JSON.stringify(payload?.body),
      });

      const response = await res.json();
      const validateData = checkStatus(response);
      return validateData?.data;
    } catch (err) {
      if (err instanceof AuthError) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(err);
    }
  }
);
